export default __webpack_public_path__ + "static/media/package1.6276c033.png";